import { DateTime, QuarterNumbers } from 'luxon';

export function onChangeQuarter(
    start: DateTime | undefined,
    currentQuarter: QuarterNumbers,
    newQuarter: QuarterNumbers,
) {
    if (start) {
        const quarterDifference = Math.abs(newQuarter - currentQuarter);
        if (newQuarter < currentQuarter) {
            return start.minus({ quarters: quarterDifference });
        } else {
            return start.plus({ quarters: quarterDifference });
        }
    }
}

export function onChangeYear(start: DateTime | undefined, currentYear: number, newYear: number) {
    if (start) {
        const yearDifference = Math.abs(newYear - currentYear);
        if (newYear < currentYear) {
            return start.minus({ years: yearDifference });
        } else if (newYear > currentYear) {
            return start.plus({ years: yearDifference });
        }
    }
}

export function calculateDisplayedStart(start: DateTime, monthsBefore: number) {
    return start.startOf('quarter').startOf('day').minus({ months: monthsBefore });
}

export function calculateEndFromStart(start: DateTime, monthsAfter: number) {
    return start.startOf('quarter').plus({ months: monthsAfter + 3 });
}
